<template>
    <div class="businessSegment indexContainer detailsActive">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/admin/index',query:{ languageId: this.$route.query.languageId} }"><i class="iconfont icon-shouye"></i> {{this.breadcrumbHome}}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="this.parentTitle" @click.native="toPages('one')" class="breadcrumbSpan">{{this.parentTitle}}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="this.activeTitle" @click.native="toPages('two')" class="breadcrumbSpan">{{this.activeTitle}}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>
<script>
import { getContent} from '@/api/inner.js';
import { getBreadcrumbs } from '@/common/js/common.js'
export default {
    data(){
        return{
            activeTitle:"",
            parentTitle:"",
            modelId:"",
            getBreadcrumbsArr:[],
            moduleId:'',
            moduleTree:[],
            parentTitleType:'',
            activeTitleType:'',
            breadcrumbHome:this.$store.getters.base.breadcrumbHome || ''
        }
    },
    created(){
      this.getLocation();
    },
    methods:{
      getLocation() {
        const id = this.$route.query.id;
        if(this.$route.query.moduleId){
            this.moduleId = this.$route.query.moduleId;
        }else{
            this.moduleId =  this.$route.query.id;
        }
        // this.moduleTree = JSON.parse(localStorage.getItem('moduleTree'))
        this.moduleTree = this.$store.getters.moduleTree
        // this.breadcrumbHome  =  localStorage.getItem('breadcrumbHome')
        // if(this.moduleId){
            this.getBreadcrumbsArr = getBreadcrumbs(this.moduleId,this.moduleTree);
            this.parentTitle = this.getBreadcrumbsArr[0].name;
            this.getContent(this.getBreadcrumbsArr[0].id,this.getBreadcrumbsArr[0].level,1);
            this.activeTitle = '';
            if(this.getBreadcrumbsArr.length > 1){
                this.activeTitle = this.getBreadcrumbsArr[1].name;
                this.getContent(this.getBreadcrumbsArr[1].id,this.getBreadcrumbsArr[1].level,2);
            }
        // }
        // else{
        //     let localName = [];
        //     if(localStorage.getItem('location')){
        //         localName = JSON.parse(localStorage.getItem('location')).split('/');
        //         this.parentTitle = localName[0];
        //         if(localName[1]){
        //             this.activeTitle = localName[1];
        //         }
        //     }
        // }
      },
        // 获取单页
        async getContent(id,level,flag) {
            await getContent(id).then(res=> {
                if(flag === 1){
                    if(Number(level) === 2) {
                        if(res.data.childs.length > 0) {
                            this.parentTitleType = 2;
                        }
                    }
                }else{
                    if(Number(level) === 2) {
                        if(res.data.childs.length > 0) {
                            this.activeTitleType = 2;
                        }
                    }
                }
            })
        },
        toPages(flag) {
            let id = ''
            let level = ''
            let model = ''
            let type = ''
            if(this.moduleId){
                if(flag === 'one'){
                    id = this.getBreadcrumbsArr[0].id;
                    level = this.parentTitlelevel;
                    type = this.parentTitleType;
                    model = this.getBreadcrumbsArr[0].model;
                }else{
                    id = this.getBreadcrumbsArr[1].id;
                    level = this.getBreadcrumbsArr[1].level;
                    type = this.activeTitleType;
                    model = this.getBreadcrumbsArr[1].model;
                }
            }else{
                id = flag === 'one' ? localStorage.getItem('id') : this.$route.query.modelId;
                level = this.$route.query.level
                type = this.$route.query.type
                model = this.$route.query.model;
            }
            this.$router.push({
                name: 'INNERPAGER',
                query: {
                    model: model,
                    id: id,
                    level: level,
                    type:type,
                    languageId: this.$route.query.languageId
                },
            });
      },
    },
    watch: {
      $route(val) {
        this.getLocation();
      }
    }
}
</script>
<style lang="less" scoped>
.detailsActive{
    /deep/.el-breadcrumb{
        height: auto;
        margin-bottom: 10px;
        border-bottom: 1px solid #eee;
        color: #333;
        line-height: 26px;
    }
    /deep/.el-breadcrumb__inner{
        color: #333;
        cursor: pointer;
        line-height: 26px;
        display: inline-block;
    }
    /deep/.el-breadcrumb__inner.is-link{
        font-weight: normal!important;
    }

    .breadcrumbSpan /deep/.el-breadcrumb__inner{
        cursor: pointer;
        line-height: 27px;
    }
    @media only screen and (min-width:768px){
        /deep/.el-breadcrumb{
            height: 30px;
        }

    }
}
</style>



// WEBPACK FOOTER //
// src/components/item/patch30.vue